// vip对象枚举
export const  vipLevelObj = {
	0: '普通用户',
	1: 'vip'
}

// 会员权益枚举:key为type类型
export const  rightObj = {
	0: {
		desc: '优惠券礼包',
		img: require('../assets/img/vip-img04.png')
	},
	1: {
		desc: '专家咨询',
		img: require('../assets/img/vip-img02.png')
	},
	2: {
		desc: '政策小秘',
		img: require('../assets/img/vip-img03.png')
	},
	3: {
		desc: '查看权限',
		img: require('../assets/img/vip-img01.png')
	}
}

// 消息类型
export const messageTypeObj = {
	9: {
		desc: '优惠通知',
		logoSrc: require('../assets/img/member/msg_icon1.png')
	},
	10: {
		desc: '定时提醒',
		logoSrc: require('../assets/img/member/msg_icon2.png')
	},
	11: {
		desc: '其他',
		logoSrc: require('../assets/img/member/msg_icon3.png')
	},
}

// 消息是否已读
export const isReadObj = {
	0: '否',
	1: '是'
}

export const sourceObj = {
	'BS': '老板云',
	'H5': 'H5',
	'PA': 'H5',
	'APP': 'APP',
	'MP': '小程序',
  'BSTM': '抖音小程序'
}
// 页面显示特殊配置
// {
//   isGuideVip: false,     // 是否引导去vip
//   showAssitantIcon: false,  // 是否显示政策小秘书
// }
export const _functionConfig = {
  'BSTM' : {
    isGuideVip: false,
    showAssitantIcon: false,
    isShareConfig: false,
    isOpenVipFun: false
  }
}